import React, { useEffect, useState } from "react";
import { api } from "@/lib/api";
import PackShowcase from "@/components/PackShowcase";
import { PageLoading, LoadError } from "@/components/LoadState";

export default function PacksPage({ config }) {
  const [packs, setPacks] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(false);
  const [attempt, setAttempt] = useState(0);
  useEffect(() => {
    setLoading(true); setError(false);
    api.get("/packs").then((res) => setPacks(res.data)).catch(() => setError(true)).finally(() => setLoading(false));
  }, [attempt]);

  return (
    <div className="max-w-7xl mx-auto px-5 sm:px-8 py-14">
      <div className="mb-10">
        <div className="font-mono text-xs text-red-500 uppercase tracking-[0.3em] mb-2">Packs bimestrales</div>
        <h1 className="font-display font-black text-4xl sm:text-5xl lg:text-6xl uppercase tracking-tight text-white">
          Packs
        </h1>
        <p className="text-white/50 mt-4 max-w-xl">Cada par de meses lanzo un pack con lo mejor. Descárgalo entero.</p>
      </div>

      {loading ? (
        <PageLoading rows={4} label="Cargando packs…" testid="packs-loading" />
      ) : error ? (
        <LoadError onRetry={() => setAttempt((a) => a + 1)} testid="packs-error" />
      ) : packs.length === 0 ? (
        <div className="border border-dashed border-white/10 rounded-2xl py-24 text-center text-white/40">
          Aún no hay packs publicados.
        </div>
      ) : (
        <div className="space-y-5" data-testid="packs-grid">
          {packs.map((p) => <PackShowcase key={p.id} pack={p} config={config} />)}
        </div>
      )}
    </div>
  );
}
